import React from 'react';
import { Link } from 'react-router-dom';
import { useBlogs } from '../../common/BlogContext';

function Blog() {
  const { blogs } = useBlogs();

  return (
    <section className="tc-blog-style1">
      <div className="container">
        <div className="mb-80 js-splittext-lines">
          <div className="row">
            <div className="col-lg-9">
              <h2 className="fsz-45"> Latest Posts </h2>
            </div>
            <div className="col-lg-3 text-lg-end mt-4 mt-lg-0">
              <Link to="innerpages/blog" className="butn border rounded-pill color-orange1 border-orange1 hover-bg-orange1">
                <span>All Articles <i className="small ms-1 ti-arrow-top-right"></i></span>
              </Link>
            </div>
          </div>
        </div>
        <div className="blog-slider position-relative overflow-hidden">
          <div className="swiper-wrapper">
            {blogs.slice(0, 6).map((item, i) => (
              <div key={item.id ?? i} className="swiper-slide">
                <div className="blog-card">
                  <div className="img">
                    {item.img && <img src={item.img} alt={item.title} className="img-cover" />}
                  </div>
                  <div className="info">
                    <div className="date">
                      <div className="num fsz-45 mb-2">
                        {item.history ? item.history.replace(/[^0-9].*/, '').trim() || '—' : '—'}
                      </div>
                      <small className="fsz-12 text-uppercase color-666">
                        {item.history ? item.history.replace(/^\d+\s*/, '') : ''}
                      </small>
                    </div>
                    <div className="cont">
                      <Link to={`/blog/${item.id}`} className="title d-block fsz-24 hover-orange1 mb-15 fw-600">
                        {item.title}
                      </Link>
                      <small className="fsz-12 color-orange1">{item.subTitle}</small>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="swiper-button-next"></div>
      <div className="swiper-button-prev"></div>
    </section>
  );
}

export default Blog;